module.exports = __webpack_public_path__ + "img/head.1e19e7d7.png";